import { render, staticRenderFns } from "./collaborator-bio.vue?vue&type=template&id=0535b418&"
import script from "./collaborator-bio.vue?vue&type=script&lang=js&"
export * from "./collaborator-bio.vue?vue&type=script&lang=js&"
import style0 from "./collaborator-bio.vue?vue&type=style&index=0&id=0535b418&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports